import { Alert, Box, Theme, useMediaQuery } from '@mui/material';
import * as React from 'react';

export const MessageInfo = ({ children, isOnline }: { children?: React.ReactNode, isOnline:boolean }) => {
    const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  
  return (
    <Box>
      <Alert
        icon={false}
        variant="filled"
        severity="info"
        sx={{
          '& .MuiAlert-message': {
            width: '100%',
          },
          borderRadius: '6px',
          maxWidth: '590px',
          boxShadow: '0px 6px 10px 0px rgba(66, 65, 75, 0.15)',
          margin: '20px auto',
          ...(!isOnline && !isDesktop ? {marginTop: '140px'} : undefined),
        }}
      >
        {children}
      </Alert>
    </Box>
  );
};

